module.exports = __webpack_public_path__ + "media/test.8934d337.mp3";